import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { motion } from "framer-motion";

const FAQS = [
  { q: "How can I book a taxi with Mamta Tours & Travels in Jodhpur?", a: "You can book instantly through the booking form on this page, WhatsApp us at +91 8107172107, or call us directly. Our team confirms every ride within minutes." },
  { q: "Do you offer airport pickup and drop from Jodhpur Airport?", a: "Yes — we operate 24/7 airport transfers with meet-and-greet service. Fixed price, name-board pickup, and clean sanitized vehicles." },
  { q: "What are your outstation taxi charges from Jodhpur?", a: "Outstation rates start from ₹11/km for a Swift Dzire. We offer both one-way and round-trip cabs with transparent pricing — no hidden charges." },
  { q: "Do you provide Rajasthan tour packages with a driver?", a: "Absolutely. We offer curated 1 to 10-day packages covering Jaipur, Udaipur, Jaisalmer, Mount Abu, Pushkar and more, with a professional English-speaking driver." },
  { q: "Are your drivers professional and background-verified?", a: "Every driver at Mamta Tours is background-verified, uniformed, trained in first-aid, and holds a commercial license with 5+ years of Rajasthan road experience." },
  { q: "Can I hire a Tempo Traveller for group travel?", a: "Yes — we operate 12 and 17-seater A/C Tempo Travellers ideal for families and group tours across Rajasthan." },
  { q: "Do you offer wedding cars and corporate cabs?", a: "Yes. We provide decorated wedding cars, baraat vehicles, and monthly corporate cab contracts with GST invoicing." },
  { q: "What are your payment options?", a: "We accept cash, UPI, Google Pay, PhonePe, Paytm, credit/debit cards and NEFT for advance bookings." },
  { q: "Is a small advance required to confirm the booking?", a: "For outstation and tour packages, a small refundable advance (typically 10-20%) confirms your booking. Local city rides can be booked without advance." },
  { q: "Do your vehicles have GPS tracking?", a: "Yes, all vehicles are GPS-enabled. On outstation and tour bookings we share a live-tracking link with your family for peace of mind." },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-white text-brand-ink py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-[1100px] mx-auto px-4 md:px-8">
        <div className="text-center md:text-left">
          <div className="text-[11px] uppercase tracking-[0.28em] font-semibold text-brand-blue">Chapter VIII · Frequently asked</div>
          <h2 className="mt-4 font-display font-black text-5xl md:text-6xl leading-[1.02]">
            Questions? <span className="italic text-brand-orange font-medium">Answered.</span>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mt-12 rounded-3xl border border-brand-ink/8 bg-brand-cream/50 divide-y divide-brand-ink/5 px-6 md:px-10"
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-brand-ink/8 last:border-b-0">
                <AccordionTrigger className="py-6 text-left font-display text-lg md:text-xl font-semibold hover:no-underline text-brand-ink [&[data-state=open]]:text-brand-blue" data-testid={`faq-trigger-${i}`}>
                  <span className="flex items-start gap-4">
                    <span className="text-brand-orange text-sm font-sans font-semibold pt-1">{String(i + 1).padStart(2, "0")}</span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-brand-ink/70 text-base leading-relaxed ml-8">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
